import { render } from "./BaseReport.vue?vue&type=template&id=778a6e12&scoped=true"
import script from "./BaseReport.vue?vue&type=script&lang=js"
export * from "./BaseReport.vue?vue&type=script&lang=js"

import "./BaseReport.vue?vue&type=style&index=0&id=778a6e12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778a6e12"]])

export default __exports__